import {
  ColumnChooser,
  ColumnDirective,
  ColumnMenu,
  ColumnsDirective,
  Edit,
  EditSettingsModel,
  ExcelExport,
  Filter,
  FilterSettingsModel,
  GridComponent,
  Group,
  Inject,
  Page,
  PageSettingsModel,
  Resize,
  Toolbar,
} from '@syncfusion/ej2-react-grids';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import {
  ButtonPropsModel,
  DialogComponent,
} from '@syncfusion/ej2-react-popups';
import React, { Component } from 'react';
import  { all_information, loadingShow } from '../../../App';
import {
  AddShiftWorkbenchSettings,
  DeleteShiftWorkbenchSettings,
  EditShiftWorkbenchSettings,
  getShiftWorkbenchSettings,
} from '../../../services/ShiftWorkbench/ShitWorkbenchSettingsServices';
import Message from '../../../utils/Message/Message';
interface IState {
  visibleAddDialog: boolean;
  visibleEditDialog: boolean;
  departmentData: any;
  visibleDeleteDialog: boolean;
  supervisorData: any;
}
interface IProps {
  GridHeight?: any;
}
export class Departments extends Component<IProps, IState> {
  private securityRoleGrid: GridComponent;
  private buttonForAdd: ButtonPropsModel[];
  private dep_name: string = '';
  private description: string = '';
  public validationRule: Object = { required: true };
  private buttonsDelete: ButtonPropsModel[];
  private departmentId: number = -1;
  private isAdd: boolean = true;
  private title: string = '';
  private type: string = 'department';
  constructor(props: IProps) {
    super(props);
    this.securityRoleGrid = new GridComponent(props);
    this.state = {
      visibleAddDialog: false,
      visibleEditDialog: false,
      departmentData: [],
      visibleDeleteDialog: false,
      supervisorData: [],
    };
    this.buttonForAdd = [
      {
        click: () => {},
        buttonModel: {
          content: 'Save',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ visibleAddDialog: false });
        },
        buttonModel: {
          content: 'Cancel',
          isPrimary: false,
        },
      },
    ];
    this.buttonsDelete = [
      {
        click: () => {
          this.deleteSites();
        },
        buttonModel: {
          content: 'Yes',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ visibleDeleteDialog: false });
        },
        buttonModel: {
          content: 'No',
        },
      },
    ];
  }
  public FilterOptions: FilterSettingsModel = { type: 'Menu' };
  public toolbarOptions = [
    'Add',
    'Edit',
    'Delete',
    'Update',
    'Cancel',
    {
      text: 'Refresh',
      tooltipText: 'Refresh',
      prefixIcon: 'e-repeat',
      id: 'refresh-m',
    },
    'ExcelExport',
    'ColumnChooser',
    'Search',
  ];
  public editOptions: EditSettingsModel = {
    allowAdding: true,
    allowDeleting: true,
    allowEditing: true,
    allowEditOnDblClick: true,
    showDeleteConfirmDialog: true,
  };
  public pageOptions: PageSettingsModel = {
    currentPage: 1,
    pageSize: 12,
    pageCount: 8,
    pageSizes: true,
  };
  deleteSites() {
    const obj = {
      id: this.departmentId,
    };
   DeleteShiftWorkbenchSettings(obj)
      .then((res) => {
        loadingShow(false);
        Message.success('Successfully');
        this.getDepartment(this.type);
        this.setState({ visibleDeleteDialog: false });
      })
      .catch((err) => {
        loadingShow(false);
        if (err.response) {
          Message.error(err.response.data+"\n"+err.response.status+"\n"+err.response.headers);
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
      });
  }
  addDepartment(objCommer: any) {
    const obj = {
      app: 'UWORK',
      user_id: all_information.user_id,
      organization_id: all_information.company_id?.toString(),
      description: objCommer.description,
      department_name: objCommer.department_name,
      id: objCommer.id,
      type:this.type
    };

    if (this.isAdd) {
        delete obj.id
        AddShiftWorkbenchSettings(obj)
        .then((res) => {
          loadingShow(false);
          Message.success('Successfully');
          this.getDepartment(this.type);
          this.setState({ visibleAddDialog: false });
        })
        .catch((err) => {
          loadingShow(false);
          if (err.response) {
            Message.error(err.response.data);
            Message.error(err.response.status);
            Message.error(err.response.headers);
          } else if (err.request) {
            Message.error(err.request);
          } else {
            Message.error('Error: ' + err.message);
          }
        });
    } else {
      EditShiftWorkbenchSettings(obj)
        .then((res) => {
          loadingShow(false);
          Message.success('Successfully');
          this.getDepartment(this.type);
          this.setState({ visibleAddDialog: false });
        })
        .catch((err) => {
          loadingShow(false);
          if (err.response) {
            Message.error(err.response.data);
            Message.error(err.response.status);
            Message.error(err.response.headers);
          } else if (err.request) {
            Message.error(err.request);
          } else {
            Message.error('Error: ' + err.message);
          }
        });
    }
  }
  componentDidMount() {
    this.getDepartment(this.type);
  }

  getDepartment(type:string) {
   getShiftWorkbenchSettings(type)
      .then((el) => {
        this.setState({ departmentData: el.data });
      })
      .catch((e) => {
        //(e);
      });
  }
  toolbarClick(args: any) {
    if (args.item.id === 'refresh') {
      this.getDepartment(this.type);
    }
    if (args.item.id === 'add') {
      this.dep_name = '';
      this.description = '';
      this.title = 'Add Department';
      this.setState({
        visibleAddDialog: true,
      });
    }
    if (args.item.id === 'delete') {
      if (this.securityRoleGrid.getSelectedRecords()) {
        if (this.securityRoleGrid.getSelectedRecords().length > 0) {
          var selectedElement =
            this.securityRoleGrid.getSelectedRecords() as any;
          this.departmentId = selectedElement[0].id;
          this.setState({ visibleDeleteDialog: true });
        }
      }
    }
    if (args.item.id === 'edit') {
      if (this.securityRoleGrid.getSelectedRecords()) {
        if (this.securityRoleGrid.getSelectedRecords().length > 0) {
          var selectedElement =
            this.securityRoleGrid.getSelectedRecords() as any;
          this.title = 'Edit Department';

          this.dep_name = selectedElement[0].department_name;
          this.description = selectedElement[0].description;
          this.departmentId = selectedElement[0].id;
          this.setState({
            visibleAddDialog: true,
          });
        }
      }
    }
  }
  actionBegin(args: any) {
    if (args.requestType === 'refresh-m') {
      this.getDepartment(this.type);
    }
    if (args.action === 'add') {
      this.isAdd = true;
      this.addDepartment(args.data);
    } else if (args.action === 'edit') {
      this.isAdd = false;
      this.addDepartment(args.data);
    } else if (args.requestType === 'delete') {
      this.departmentId = args.data[0].id;
      this.deleteSites();
    }
  }

  render() {
    return (
      <div>
        <GridComponent
          id='gridShiftworkbenchDepartments'
          editSettings={this.editOptions}
          toolbar={this.toolbarOptions}
          dataSource={this.state.departmentData}
          height='65vh'
          ref={(theGrid: GridComponent) => (this.securityRoleGrid = theGrid)}
          filterSettings={this.FilterOptions}
          actionBegin={this.actionBegin.bind(this)}
          allowFiltering={true}
          allowPaging={true}
          enablePersistence
          pageSettings={this.pageOptions}
          allowExcelExport
          showColumnMenu={true}
          allowResizing={true}
          allowGrouping={true}
          toolbarClick={this.toolbarClick.bind(this)}
          gridLines='Both'
        >
          <ColumnsDirective>
            <ColumnDirective
              field='department_name'
              headerText='Department Name'
              textAlign='Left'
              validationRules={this.validationRule}
            />
            <ColumnDirective
              field='description'
              headerText='Description'
              validationRules={this.validationRule}
              textAlign='Left'
            />
          </ColumnsDirective>
          <Inject
            services={[
              Edit,
              Toolbar,
              Filter,
              ColumnChooser,
              ExcelExport,
              Page,
              ColumnMenu,
              Resize,
              Group
            ]}
          />
        </GridComponent>
        {this.state.visibleAddDialog ? (
          <DialogComponent
            animationSettings={{ delay: 1, duration: 500, effect: 'FadeZoom' }}
            visible={this.state.visibleAddDialog}
            header={this.title}
            close={() => {
              this.setState({ visibleAddDialog: false });
            }}
            open={() => {
              this.setState({ visibleAddDialog: true });
            }}
            buttons={this.buttonForAdd}
            isModal
            showCloseIcon
            width={'300px'}
          >
            <div className='container'>
              <div className='row'>
                <div className='col-md-12'>
                  <TextBoxComponent
                    placeholder='Department Name'
                    floatLabelType='Auto'
                    value={this.dep_name}
                    onChange={(el: any) => {
                      this.dep_name = el.value;
                    }}
                  />
                </div>

                <div className='col-md-12'>
                  <TextBoxComponent
                    placeholder='Description'
                    floatLabelType='Auto'
                    value={this.description}
                    onChange={(e: any) => {
                      this.description = e.value;
                    }}
                  />
                </div>
              </div>
            </div>
          </DialogComponent>
        ) : null}

        {this.state.visibleDeleteDialog ? (
          <DialogComponent
            isModal={true}
            id='defaultDialogDelete'
            showCloseIcon={true}
            visible={this.state.visibleDeleteDialog}
            header='Confirmation'
            width={200}
            height={'auto'}
            buttons={this.buttonsDelete}
            open={() => {
              this.setState({ visibleDeleteDialog: true });
            }}
            close={() => {
              this.setState({ visibleDeleteDialog: false });
            }}
          >
            <div className='container'>
              <div className='row'>
                <span>Are you sure?</span>
              </div>
            </div>
          </DialogComponent>
        ) : null}
      </div>
    );
  }
}

export default Departments;